import { render, staticRenderFns } from "./zj-bar.vue?vue&type=template&id=496fd1b9&"
import script from "./zj-bar.vue?vue&type=script&lang=js&"
export * from "./zj-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496fd1b9')) {
      api.createRecord('496fd1b9', component.options)
    } else {
      api.reload('496fd1b9', component.options)
    }
    module.hot.accept("./zj-bar.vue?vue&type=template&id=496fd1b9&", function () {
      api.rerender('496fd1b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/zj-chart/zj-bar.vue"
export default component.exports